<section fxLayoutAlign="end center">
  <sbnb-close [border]="true" (click)="dialogRef.close()"></sbnb-close>
</section>

<section fxFlexFill fxLayout fxLayoutAlign="center center">
  <div class="fs-dialog-contents">
    <div *ngIf="loadingQuote" class="skeleton-contents">
      <div class="skeleton-line"></div>
      <div class="skeleton-line"></div>
      <div class="skeleton-line short"></div>
    </div>

    <div class="main" *ngIf="!loadingQuote">
      <ng-template *ngIf="dialogData.newPlan === 'basic'" [ngTemplateOutlet]="downgradeToBasicTemplate"></ng-template>
      <ng-template *ngIf="dialogData.newPlan === 'premium'" [ngTemplateOutlet]="upgradeToPremiumTemplate"></ng-template>
      <ng-template
        *ngIf="dialogData.newPlan === 'keep-priority-support'"
        [ngTemplateOutlet]="keepPrioritySupportTemplate"></ng-template>
    </div>

    <aside>
      <img src="/assets/images/priority-support/{{ dialogData.newPlan }}-stage-{{ stage }}.png" />
    </aside>
  </div>
</section>

<ng-template #keepPrioritySupportTemplate>
  <h2>Keep Priority Support</h2>

  <ul>
    <li>
      You are currently eligible for Priority Support until
      {{ user.priority_support.priority_support_ends_at | date: 'longDate' }}.
    </li>
    <li>After this date, you will be downgraded and lose access to Priority support.</li>
    <li>If you would like to keep Priority support after this date, you will continue to be charged.</li>
  </ul>

  <mat-checkbox [(ngModel)]="keepPrioritySupportChecked">
    I would like to keep Priority Support and will continue to be charged.
  </mat-checkbox>

  <sbnb-button (clicked)="keepPrioritySupport()">Keep Priority Support</sbnb-button>
</ng-template>

<ng-template #downgradeToBasicTemplate>
  <ng-container *ngIf="stage === 1">
    <h2>Downgrade to Award-Winning Support</h2>
    <span>Thanks for trying Priority Support! As you would like to downgrade to Award-Winning Support:</span>

    <ul>
      <li>
        <strong>
          You will have access to Priority Support until {{ quote.adhoc_charge_until | date: 'longDate' }}.
        </strong>
      </li>
      <li>
        After that date, our support team will reply as fast as they can, with the same high-quality answers, but your
        conversation will no longer be marked as priority.
      </li>
      <li>
        You will no longer have access to WhatsApp support. Messages sent to our WhatsApp support number will no longer
        be received.
      </li>
    </ul>

    <mat-checkbox [(ngModel)]="hasCheckedCancelBox">
      I agree to downgrade to Award-Winning Support on {{ quote.adhoc_charge_until | date: 'longDate' }}
    </mat-checkbox>

    <sbnb-button [loading]="cancelling" (clicked)="confirmDowngrade()">Confirm downgrade</sbnb-button>
  </ng-container>
</ng-template>

<ng-template #upgradeToPremiumTemplate>
  <ng-container *ngIf="stage === 1">
    <h2>Upgrading to Priority Support</h2>

    <div fxLayout="column" fxLayoutGap="16px" style="margin-bottom: 36px">
      <span>
        With Priority Support, all your conversations over live chat, email, or WhatsApp are marked as a priority to the
        support team.
      </span>
      <span>Priority Support is an add-on to your monthly invoice.</span>

      <span>
        0-2 active properties ...............
        <strong>{{ quote.priority_support_base_addon_amount }} per month (minimum)</strong>
      </span>
      <span>
        3-∞ active properties...............
        <strong>{{ quote.priority_support_addon_amount_per_property }} per property per month</strong>
      </span>

      <span>
        Upon activation, we will charge you with a prorated one-off invoice to cover your Priority Support until
        {{ quote.adhoc_charge_until | date: 'longDate' }}. Priority Support will then be an add-on to your monthly
        invoice, until you cancel it.
      </span>
    </div>

    <sbnb-button (clicked)="stage = 2">Next: WhatsApp</sbnb-button>
  </ng-container>

  <ng-container *ngIf="stage === 2">
    <h2>Upgrading to Priority Support</h2>

    <div fxLayout="column" fxLayoutGap="16px" style="margin-bottom: 36px">
      <span>
        To identify your account on WhatsApp, we need to confirm that the phone number associated with your Hospitable
        account is correct. Only one phone number will have access to WhatsApp support.
      </span>

      <span>Can you confirm the phone number associated with your number is a valid WhatsApp phone number?</span>

      <mat-form-field class="fw nopadding support-phone-input">
        <ngx-mat-intl-tel-input
          [disabled]="true"
          [enablePlaceholder]="true"
          [(ngModel)]="user.phone"
          placeholder="You don't have a phone number set. Set one in your profile."></ngx-mat-intl-tel-input>
      </mat-form-field>

      <span>You can update your phone number on your personal info page.</span>
    </div>

    <sbnb-button (clicked)="stage = 3">Confirm my phone number</sbnb-button>
  </ng-container>

  <ng-container *ngIf="stage === 3">
    <h2>Upgrading to Priority Support</h2>

    <span>Everything should be ready now, here is the recap!</span>

    <ul>
      <li>Priority Support is a recurring add-on, valid until cancelled.</li>
      <li>You will be charged today a one-off invoice for {{ quote.charge_amount }}.</li>
      <li>
        You will then be charged {{ quote.priority_support_base_addon_amount }} per month, plus
        {{ quote.priority_support_addon_amount_per_property }} per active property.
      </li>
      <li>The phone number associated with your account is {{ user.phone }}.</li>
    </ul>

    <span>
      On the next screen you will be presented with a {{ (isMobile$ | async) ? 'link' : 'QR code' }} to start your
      WhatsApp conversation. {{ (isMobile$ | async) ? '' : 'Get your phone ready!' }}
    </span>

    <div style="margin-top: 24px">
      <mat-checkbox [(ngModel)]="hasCheckedUpgradeBox">
        I agree to subscribe to the Priority Support add-on.
      </mat-checkbox>
    </div>

    <sbnb-button [loading]="upgrading" (clicked)="upgrade()">Upgrade to Priority Support</sbnb-button>
  </ng-container>

  <ng-container *ngIf="stage === 4">
    <h2>Congrats! You have been upgraded! 🎉</h2>

    <div fxLayout="column" fxLayoutGap="16px" style="margin-bottom: 36px">
      <span>
        Starting from now, all your conversations will be marked as priority so they are served first by our
        award-winning support team.
      </span>

      <ng-container *ngIf="!(isMobile$ | async)">
        <span>Start your first WhatsApp support conversation.</span>

        <span>Scan the QR code and follow the steps!</span>
      </ng-container>

      <div *ngIf="isMobile$ | async" style="padding-top: 16px">
        <a class="whatsapp-link" href="https://wa.me/message/B3LQSODKAFLGC1" target="_blank">
          <sbnb-button type="secondary" icon="whatsapp">Start your first WhatsApp support conversation</sbnb-button>
        </a>
      </div>
    </div>
  </ng-container>
</ng-template>
